module.exports = __webpack_public_path__ + "static/media/step-pagamento-active.7dae70c3.svg";